import {
  CONVERSATION_TYPES,
  ROLES
} from '../../config/constants'

export default (item) => {
  const {GUEST, NORMAL, EXPERT, GROUP} = CONVERSATION_TYPES

  if (!item.get('uid')) return GROUP
  if (!item.get('role')) return GUEST
  if (item.get('role') === ROLES.EXPERT) return EXPERT

  return NORMAL
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/predict_conversation_type.js
 **/